import { postRequest } from './apiHandler';
import { TimeZoneList } from './tzConstant';

export const messageCounterHelper = (message) => {
  // GSM messages: 160 chars for single message, 153 chars for concatenated messages
  const singleMessageLimit = 160;
  const concatenatedMessageLimit = 153;

  const chars = message.length;
  const messageCount =
    chars <= singleMessageLimit ? 1 : Math.ceil(chars / concatenatedMessageLimit);
  const remainingChars =
    messageCount === 1
      ? singleMessageLimit - chars
      : messageCount * concatenatedMessageLimit - chars;

  return {
    messageCount: messageCount,
    messageCharCounter: remainingChars,
  };
};

// Create new campaign
export const createNewCampaign = (access_token) =>
  new Promise((resolve, reject) => {
    postRequest('/campaign', {}, access_token.token, (ret) => {
      if (ret.success) {
        resolve(ret);
      } else {
        reject(ret);
      }
    });
  });

export const modifyMessageAndFields = (message, fields) => {
  const newFields = [];
  fields.forEach((field) => {
    if (message.includes(`{${field.key}}`)) {
      newFields.push(field);
    }
  });
  return newFields;
};

// Sort by aplha
const sortByAlpha = (timezone1, timezone2) => {
  if (timezone1.label.toLowerCase() < timezone2.label.toLowerCase()) {
    return -1;
  }
  if (timezone1.label.toLowerCase() > timezone2.label.toLowerCase()) {
    return 1;
  }
  return 0;
};

export const getTimezone = () => {
  const timezones = TimeZoneList;
  const formattedTimezone = [];

  timezones.forEach((timezone) => {
    formattedTimezone.push({
      value: timezone.tzCode,
      label: timezone.label.replace(/_/g, ' '),
    });
  });

  // Sort array
  formattedTimezone.sort(sortByAlpha);

  return formattedTimezone;
};

export const formatCurrency = (currency, value, minimumFractionDigits = 2) => {
  // const minimumFractionDigits = fractionUpto || 2;
  let countryLocale = 'ms-MY';
  if (currency === 'USD') {
    countryLocale = 'en-US';
  }
  if (currency === 'EUR') {
    countryLocale = 'eu'; // using spain locale as default
  }
  const intlCurrency = new Intl.NumberFormat(countryLocale, {
    style: 'currency',
    currency: currency,
    // notation: 'compact',
    minimumFractionDigits: minimumFractionDigits,
  }).format(value);
  return intlCurrency;
};

export const formatWithoutCurrency = (value, minFraction = 2, maxFraction = 2) => {
  const intlCurrency = new Intl.NumberFormat('en-US', {
    // notation: 'compact',
    minimumFractionDigits: minFraction,
    maximumFractionDigits: maxFraction < minFraction ? minFraction : maxFraction,
  }).format(value);
  return intlCurrency;
};

export const formatNumber = (number, fractionUpto) => {
  if (Number.isInteger(number)) {
    return number;
  }
  return number.toFixed(fractionUpto);
};

// Return tax amount
export const calcuTaxAmount = (amount, tax) => {
  const taxAmount = tax * amount;
  return {
    taxAmount: taxAmount,
    amountAfterTax: taxAmount + amount,
  };
};

/**
 * Handler long text
 */
export const truncateString = (str = '', strEnd = 10) => {
  if (str) {
    return str.length > strEnd ? `${str.substring(0, strEnd)}...` : str;
  }
};

export const campaign_calculator = ({
  sms_count = 0,
  message_count = 1,
  total_sms_price = 0,
} = {}) => {
  // total_sms_price is now price per single SMS
  const total_sms_cost = total_sms_price * sms_count * message_count;
  const total = total_sms_cost;

  return {
    subtotal: total_sms_cost.toFixed(2),
    total: total.toFixed(2),
  };
};

/*
 * TitleCase a string
 * */
export const titleCase = (str) => {
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

// Emails for which SMS cost figures and CSV/Excel exports are hidden (requested by Ellen.).
const HIDE_COST_EMAILS = ['norsuzila.k@fgvholdings.com', 'noorazuan.n@msmsugar.com'];

export const hideCostForUser = (email) => HIDE_COST_EMAILS.includes((email || '').toLowerCase());
